if (
  typeof Array !== undefined
  && Array.prototype
  && !Array.prototype.moveByOffset
) {
  Object.defineProperty(Array.prototype, 'moveByOffset', {
    value(value, offset) {
      const index = this.indexOf(value);
      const newIndex = index + offset;
      if (newIndex > -1 && newIndex < this.length) this.splice(newIndex, 0, this.splice(index, 1)[0]);
      return this;
    }
  });
}